import React, { useState, useRef, useEffect } from "react";
import styles from "../int.module.css";
import { TextField } from "@mui/material";

export default function IntUI(props) {
  const {
    key_id,
    field,
    title,
    onUpdate,
    enableQuery,
    length,
    placeHolder,
    value_position = "value",
    value_name_position = "value_name",
    units = "",
    item_specific_error_validator,
    setParentFieldError,
    value,
    onChange,
    error,
    disabled = false,
  } = props;

  const ref = useRef(null);

  const local_validation = (value) => /^[0-9]{1,12}$/.test(value);

  const onKeyDown = (key) => {
    if (key.keyCode === 13) {
      ref.current.blur();
    }
  };

  const onBlur = () => {
    onUpdate();
  };

  const is_error = () => {
    if (value?.length === 0) {
      //this is used for randomization checking and flogic at the form level
      setParentFieldError && setParentFieldError(key_id, true);
      return false;
    } else {
      let error = !local_validation(value);
      if (item_specific_error_validator && item_specific_error_validator.constructor === Function) {
        error = local_validation() || item_specific_error_validator(value);
      }

      //this is used for randomization checking and flogic at the form level
      setParentFieldError && setParentFieldError(key_id, error);
      return error;
    }
  };

  return (
    <div className={styles.int_ui}>
      <div>
        <TextField
          type="text"
          inputRef={ref}
          placeholder={placeHolder || ""}
          value={value}
          onChange={(e) => {
            let value = e.target.value;
            if (/^([0-9]+){0,4}$/.test(value)) {
              onChange(value);
            }
            if (is_error(value)) {
              setParentFieldError && setParentFieldError(key_id, true);
            } else {
              setParentFieldError && setParentFieldError(key_id, false);
            }
          }}
          inputProps={{ maxLength: length }}
          autoComplete="off"
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          sx={{
            "& .MuiInputBase-input": {
              padding: "5px",
              textAlign: "center",
              width: `${length * 10 + 10}px`,
              fontSize: 14,
            },
          }}
          error={error || is_error()}
          disabled={disabled}
        />
      </div>
      {units ? <div className={styles.input_description}>{units}</div> : null}
      {field?.calculated ? <div className={styles.calculated_text}>(calculated)</div> : null}
    </div>
  );
}
